// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/sites/v1/service

import type {
  CreateSiteRequest,
  CreateSiteResponse,
  DeleteSiteRequest,
  DeleteSiteResponse,
  GetSiteRequest,
  GetSiteResponse,
  ListSitesRequest,
  ListSitesResponse,
  UpdateSiteRequest,
  UpdateSiteResponse,
} from "@proto/gen/sites/v1/service"
import { create } from "zustand"
import { devtools, persist, subscribeWithSelector } from "zustand/middleware"
import { createJSONStorage } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createMethodState, requestKey } from "../../runtime/middleware"
import { boundedLocalStorage } from "../../runtime/storage"
import type { MethodState } from "../../runtime/types"
import { getSiteClient } from "./client"

export interface SiteServiceState {
  /** State for listSites method */
  listSites: MethodState<ListSitesResponse>
  /** State for createSite method */
  createSite: MethodState<CreateSiteResponse>
  /** State for getSite method */
  getSite: MethodState<GetSiteResponse>
  /** State for updateSite method */
  updateSite: MethodState<UpdateSiteResponse>
  /** State for deleteSite method */
  deleteSite: MethodState<DeleteSiteResponse>
  /** Call listSites method */
  listSitesAsync: (req: ListSitesRequest) => Promise<ListSitesResponse>
  /** Call createSite method */
  createSiteAsync: (req: CreateSiteRequest) => Promise<CreateSiteResponse>
  /** Call getSite method */
  getSiteAsync: (req: GetSiteRequest) => Promise<GetSiteResponse>
  /** Call updateSite method */
  updateSiteAsync: (req: UpdateSiteRequest) => Promise<UpdateSiteResponse>
  /** Call deleteSite method */
  deleteSiteAsync: (req: DeleteSiteRequest) => Promise<DeleteSiteResponse>
}

/**
 * Zustand store for SiteService
 *
 * Features:
 * - Auto-manages loading/error states per method
 * - Supports fine-grained reactivity with subscribeWithSelector
 * - Optional persistence to localStorage
 * - Redux DevTools integration
 */
export const useSiteServiceStore = create<SiteServiceState>()(
  devtools(
    persist(
      subscribeWithSelector(
        immer((set) => ({
          listSites: createMethodState<ListSitesResponse>(),
          async listSitesAsync(req: ListSitesRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listSites
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getSiteClient().listSites(req)
              set((state) => {
                const slot = state.listSites
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listSites
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createSite: createMethodState<CreateSiteResponse>(),
          async createSiteAsync(req: CreateSiteRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createSite
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getSiteClient().createSite(req)
              set((state) => {
                const slot = state.createSite
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createSite
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getSite: createMethodState<GetSiteResponse>(),
          async getSiteAsync(req: GetSiteRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getSite
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getSiteClient().getSite(req)
              set((state) => {
                const slot = state.getSite
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getSite
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateSite: createMethodState<UpdateSiteResponse>(),
          async updateSiteAsync(req: UpdateSiteRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateSite
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getSiteClient().updateSite(req)
              set((state) => {
                const slot = state.updateSite
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateSite
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteSite: createMethodState<DeleteSiteResponse>(),
          async deleteSiteAsync(req: DeleteSiteRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteSite
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getSiteClient().deleteSite(req)
              set((state) => {
                const slot = state.deleteSite
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteSite
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
        }))
      ),
      {
        name: "site-store",
        // Bounded, non-throwing localStorage (see runtime/storage.ts): an
        // oversized or failing cache write is dropped rather than surfaced,
        // so it can never abort an unrelated store action.
        storage: createJSONStorage(() => boundedLocalStorage, {
          replacer: (key, value) => {
            // Convert BigInt to string for JSON serialization
            if (typeof value === "bigint") {
              return value.toString()
            }
            return value
          },
          reviver: (key, value) => {
            // Optionally convert string back to BigInt on deserialization
            // (but keeping as string is usually fine for display)
            return value
          },
        }),
        partialize: (state) => {
          // Only persist data, not loading/error states
          const persistedState: Partial<SiteServiceState> = {}
          {
            const slot = state.listSites
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listSites = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListSitesResponse>
            }
          }
          {
            const slot = state.createSite
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createSite = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateSiteResponse>
            }
          }
          {
            const slot = state.getSite
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getSite = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetSiteResponse>
            }
          }
          {
            const slot = state.updateSite
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateSite = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateSiteResponse>
            }
          }
          {
            const slot = state.deleteSite
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteSite = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteSiteResponse>
            }
          }
          return persistedState
        },
        // Persisted state written before request-keyed caching lacks `byKey`.
        // The default shallow merge replaces each method slot wholesale, which
        // would drop the freshly-initialized `byKey` map and make reads/writes
        // to `byKey[...]` throw. Re-add `byKey` for any rehydrated slot, and
        // surface any legacy top-level `data` under the no-request key so
        // no-arg hooks (the only request shape we can reconstruct) still see it
        // instead of `undefined`. Keyed reads for other requests fall through
        // to a fresh fetch, so we never serve one request's data for another.
        merge: (persisted, current) => {
          const merged = { ...current, ...(persisted as object) } as SiteServiceState
          for (const slot of Object.values(merged as unknown as Record<string, unknown>)) {
            if (
              slot &&
              typeof slot === "object" &&
              "data" in slot &&
              !("byKey" in (slot as object))
            ) {
              const s = slot as unknown as { data: unknown; byKey: Record<string, unknown> }
              s.byKey =
                s.data !== undefined
                  ? { [requestKey(undefined)]: { data: s.data, loading: false, error: undefined } }
                  : {}
            }
          }
          return merged
        },
      }
    ),
    { name: "SiteService" }
  )
)
